import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isInviteModalOpen: false,
    selectedSmsCountry: {},
    selectedWhatsAppCountry: {},
    joinMeetingSmsTemplate: "",
};

const inviteReducerSlice = createSlice({
    name: "inviteReducer",
    initialState,
    reducers: {
        setIsInviteModalOpen(state, action) {
            state.isInviteModalOpen = action.payload;
        },
        setSelectedSmsCountry(state, action) {
            state.selectedSmsCountry = action.payload;
        },
        setSelectedWhatsAppCountry(state, action) {
            state.selectedWhatsAppCountry = action.payload;
        },
        setJoinMeetingSmsTemplate(state, action) {
            state.joinMeetingSmsTemplate = action.payload;
        },
        resetInviteReducer() {
            return initialState;
        },
    },
});

export const { setIsInviteModalOpen, setSelectedSmsCountry, setSelectedWhatsAppCountry, setJoinMeetingSmsTemplate, resetInviteReducer } =
    inviteReducerSlice.actions;
export default inviteReducerSlice.reducer;
